module.exports = __webpack_public_path__ + "static/media/full_conversation_bottom.df5d7dd1.svg";